<template>
  <div>
    <div
      class="conversion-block"
      @click="simulateClickOnLink"
    >
      <div class="conversion-block__element-container">
        <div class="conversion-block__image-wrapper">
          <ica-tag
            v-if="labelText"
            v-edit="'LabelText'"
            size="small"
            class="conversion-block__tag"
          >
            <template #content>
              {{ labelText }}
            </template>
          </ica-tag>

          <epi-property
            id="Image"
            text="Bild"
          />

          <epi-picture
            :image="image"
            :sizes="dimensions"
            :use-picture="false"
            :auto-aspect-ratio="false"
          />
        </div>
      </div>

      <div class="conversion-block__content">
        <h3
          v-if="title"
          v-edit="'Title'"
          class="conversion-block__heading"
        >
          <a
            ref="conversionBlockLink"
            v-edit="'Url'"
            :href="url"
            class="conversion-block__link"
            @click.stop="trackClick()"
          >{{ title }}</a>
        </h3>
        <div
          v-if="preamble"
          v-edit="'Preamble'"
          class="conversion-block__preamble"
        >
          {{ preamble }}
        </div>
        <button
          v-if="buttonLabel"
          v-edit="'ButtonLabel'"
          type="button"
          class="conversion-block__button button button--40"
        >
          {{ convertButtonLabel(buttonLabel) }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import "#/Navigation/ArrowRight"
import IcaTag from '~/@ica/ica-molecules-vue/dist/Tag'
import dataLayer from '@/analytics/dataLayer'

export default {
  name: "ConversionBlock",
  components: {
    IcaTag
  },
  props: {
    image: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ""
    },
    labelText: {
      type: String,
      default: ""
    },
    buttonLabel: {
      type: String,
      default: "Läs mer"
    },
    preamble: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      dimensions: {
        small: {
          height: 228,
          width: 120
        },
        medium: {
          height: 288,
          width: 470
        },
        large: {
          height: 184,
          width: 296
        }
      }
    }
  },
  methods: {
    simulateClickOnLink () {
      this.$refs.conversionBlockLink.click()
    },
    convertButtonLabel (buttonLabel) {
      if (this.$root.isSmallViewport) {
        return buttonLabel.length < 20 ? buttonLabel : 'Läs mer'
      }
      return buttonLabel
    },
    trackClick () {
      dataLayer.add({
        event: 'conversionBlockSelect',
        linkName: this.buttonLabel || this.title,
        linkUrl: !/^https?:\/\//i.test(this.url) ? window.location.origin + this.url : this.url,
        ...this.tracking
      })
    }
  },
}
</script>
<style lang="scss">
.conversion-block {
  display: flex;
  border-radius: 2rem;
  overflow: hidden;
  background: $color-white;
  height: 100%;
  width: 100%;
  min-height: 228px;
  box-shadow: $box-shadow-primary;

  @include media-breakpoint-up(md) {
    display: block;
    min-height: auto;
    border-radius: 2.5rem;
  }

  &:not(:last-child) {
    margin-bottom: 0.5rem;

    @include media-breakpoint-up(md) {
      margin-bottom: 0;
    }
  }

  &__link {
    @include font(rubrik, 2, "bold");

    @include media-breakpoint-up(md) {
      @include font(rubrik, 3, "bold");
    }

    @include media-breakpoint-up(lg) {
      @include font(rubrik, 2, "bold");
    }
  }

  &:hover,
  &:focus {
    cursor: pointer;

    .conversion-block__link {
      color: $color-pink-light;
    }
  }

  &:active {
    .conversion-block__link {
      color: $color-red-dark;
    }
  }

  &__element-container {
    position: relative;
    padding-right: 7.5rem;

    @include media-breakpoint-up(md) {
      width: 100%;
      height: 216px;
      margin: 0 auto;
    }

    @include media-breakpoint-up(lg) {
      height: 184px;
    }
  }

  &__image-wrapper {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;

    .epi-picture,
    .epi-background-container,
    .empty-image-placeholder {
      height: 100%;
    }
  }

  &__tag {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 2.375rem;
  }

  &__content {
    padding: 2rem 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @include media-breakpoint-up(md) {
      height: calc(100% - 216px);
      text-align: center;
      padding: 2rem 3.75rem 3rem;
      align-items: stretch;
      flex-basis: auto;
    }

    @include media-breakpoint-up(lg) {
      padding: 2rem 2rem 3rem;
      height: calc(100% - 184px);
    }
  }

  &__heading {
    margin: 0;
  }

  &__preamble {
    flex-grow: 1;
    color: $color-grey-dark;

    @include font(text, 3, "normal");

    @include media-breakpoint-up(md) {
      margin-top: 0.25rem;
    }
  }

  &__button {
    margin-top: 1.5rem;
  }
}
</style>
